var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcConfirmX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.706 11.48a2.118 2.118 0 0 1-1.983 1.353H5.28c-.887 0-1.663-.53-1.983-1.353a2.11 2.11 0 0 1 .554-2.34L6.214 7h1.581l2.357 2.14c.653.596.869 1.512.554 2.34z",
    fill: "#D5D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.703 2.52A2.118 2.118 0 0 0 8.72 1.167H5.278a2.118 2.118 0 0 0-1.423 3.692l2.357 2.14h1.58l2.357-2.14a2.12 2.12 0 0 0 .554-2.34zM8.061 4.217H5.937a.397.397 0 0 1-.396-.396.4.4 0 0 1 .396-.397h2.124c.221 0 .396.18.396.397a.4.4 0 0 1-.396.396z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConfirmX);
export default __webpack_public_path__ + "static/media/ic-confirm-x.05a7c0eccfeefd71c23398235c6659e0.svg";
export { ForwardRef as ReactComponent };